/**
 * ?taskId=<live _id> deep-link resolution: find the task across whichever
 * pools are already loaded client-side (same "list already fetched, filter
 * locally" convention PromptPage.jsx uses for editing by id — there's no
 * dedicated get-task-by-id endpoint). Doesn't resolve "unavailable" until
 * every pool has actually finished loading, so a slow fetch never flashes
 * that state for a task that's really just still loading.
 */
export function resolveTaskById(taskId, pools, poolsLoaded) {
  if (!taskId) return { status: "none" };
  if (!poolsLoaded) return { status: "loading" };
  const task = pools.flat().find((t) => (t?._id || t?.id) === taskId);
  return task ? { status: "found", task } : { status: "unavailable" };
}
